import { Injectable } from '@angular/core';
import { HttpHandler, HttpEvent, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from './auth.service';


@Injectable()
export class AuthHandler extends HttpHandler {
    // Este handler intercepta todas las peticiones HTTP y añade el token de autenticación
    // para los servicios que no esten dentro del módulo MMK, TA, etc (que ya tienen el token en interceptor)
    constructor(
        private readonly authenticationService: AuthenticationService,  
        private readonly next: HttpHandler   
    ) {
        super();
    }

    /** @override */ handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
        const jwtToken = this.authenticationService.getJwtToken();
        const jwtTokenValid = !this.authenticationService.isTokenExpired();
        let clone;
        if (jwtTokenValid) {
            clone = req.clone({
                setHeaders: { Authorization: `Bearer ${jwtToken}` }
            });
        } else {
            return this.next.handle(req);
        }
        
        return this.next.handle(clone);
    }
}